import React, { useEffect, useState } from "react";

import { getCanvasBundle } from "js/canvas";
import AppController from "js/core/AppController";
import { ds } from "js/core/models/dataService";
import { BuiltInThemes } from "js/core/models/theme";
import UndoManager from "js/core/services/undoManager";
import { app } from "js/namespaces";
import { AuthConsumer } from "js/react/views/Auth/AuthConsumer";
import { FirebaseAuthProvider } from "js/react/views/Auth/FirebaseAuthContext";

import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.PPT_ADDIN);

function PPTAddinAppInitializer({ children }) {
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        logger.info("[PPTAddin][PPTAddinAppInitializer] mounted");

        (async () => {
            // This is an ugly hack that allows presentation model to pull the correct
            // implementations
            ds.prepare({ BuiltInThemes });
            app.getCanvasBundle = getCanvasBundle;
            app.undoManager = new UndoManager();
            app.appController = AppController;

            const { default: Adapter } = await import(/* webpackMode: "eager" */ "js/core/storage/adapter");
            const { default: FirebaseAdapter } = await import(/* webpackMode: "eager" */ "js/core/storage/firebaseAdapter");
            Adapter.setDefaultClass(FirebaseAdapter);

            Office.initialize = () => { };
            Office.onReady(() => setReady(true));
        })();
    }, []);

    if (!isReady) {
        return <div></div>;
    }

    return (
        <FirebaseAuthProvider>
            <AuthConsumer>
                {() => children}
            </AuthConsumer>
        </FirebaseAuthProvider>
    );
}

export default PPTAddinAppInitializer;
